import { style } from '@vanilla-extract/css';

export const embedTitleContainer = style({
  color: 'var(--wt-hyperlink-title-color)',
  fontWeight: 'bold',
  paddingBottom: '6px',
  textAlign: 'left',
});

export const embedTitleParagraph = style({
  fontFamily: 'var(--wt-hyperlink-font, var(--wt-hyperlink-font-family, inherit))',
  fontSize: 'var(--wt-hyperlink-title-size, 20px)',
  lineHeight: 'var(--wt-generic-embed-title-line-height, 28px)',
  margin: '0',
});
